import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'auto-direct',
  styleUrls: ['./auto-direct.component.scss'],
  templateUrl: 'auto-direct.component.html',
})
export class AutoDirectComponent implements OnInit {
  async ngOnInit() {}
}
